import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { DownloadBillingForm } from '@/components/forms/DownloadBillingForm'

export default function DownloadBillingPage() {
  const navigate = useNavigate()
  const params = useParams<{ shippingLineId: string; billingId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const billingStatementId = params.billingId ? parseInt(params.billingId, 10) : undefined

  const finalShippingLineId = paramsShippingLineId
  const finalBillingStatementId = billingStatementId
  console.log('finalBillingStatementId', params.billingId)

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Download Billing Statement
            </Heading>
          </CardHeader>
          <CardBody>
            <DownloadBillingForm
              billingStatementId={finalBillingStatementId}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
